export default __webpack_public_path__ + "static/media/joys550_check_valve_before_meter.f8c2e95e.png";